<template>
  <div style="min-height: 145px">
    <!-- Overlay when paypal open -->
    <v-overlay :value="showOverlay"></v-overlay>
    <div id="submitContainer" class="submit-container flex-col items-center">
      <v-btn
        rounded
        light
        elevation="0"
        color="secondary"
        class="avm-btn avm-btn--large mx-auto xl:block"
        :class="{
          'hide-on-paypal': stepper.loading && paymentMethod == 'paypal',
          hidden: !reserveArea
        }"
        :loading="stepper.loading"
        @click="submitStep"
      >
        {{
          reserveArea
            ? $t("shared.confirm_extras")
            : $t("shared.confirm_reservation")
        }}
      </v-btn>
      <paypal-component
        class="mt-8"
        v-show="paymentMethod == 'paypal' && showPaypal"
        @hide-paypal="showPaypalToFalse()"
        @hide-overlay="showOverlayToFalse()"
        @paypal-approved="$emit('paypal-approved')"
        :gift="gift"
        :nights="nights"
        :extras="extras"
      ></paypal-component>
    </div>
  </div>
</template>

<script>
import { GET_PAYMENT_METHOD } from "../../../../../../../store/getter-types";
import { SET_STEPPER_LOADING } from "../../../../../../../store/stepper/action-types";
import stepMixin from "../../../../../../../utils/mixins/stepMixin";

export default {
  mixins: [stepMixin],
  props: {
    showPaypal: Boolean,
    showOverlay: Boolean,
    gift: {
      type: Boolean,
      default: false
    },
    nights: {
      type: Boolean,
      default: false
    },
    extras: {
      type: Boolean,
      default: false
    },
    reserveArea: {
      type: Boolean,
      default: false
    }
    // titleBtn: {
    //   type: String
    // }
  },
  computed: {
    paymentMethod() {
      return this.$store.getters[GET_PAYMENT_METHOD];
    }
  },
  methods: {
    submitStep() {
      this.$store.dispatch(SET_STEPPER_LOADING, true);
      this.$emit("submit-step");
    },
    showPaypalToFalse() {
      this.$emit("show-paypal-to-false");
    },
    showOverlayToFalse() {
      this.$emit("show-overlay-to-false");
    }
  }
};
</script>

<style lang="scss" scoped>
.hide-on-paypal {
  display: none !important;
}
</style>
